import { cva, type VariantProps } from 'class-variance-authority';

const variants = cva('', {
  variants: {
    variant: {
      new: [
        'relative h-0.5 min-h-[2px] overflow-visible border-transparent bg-[radial-gradient(circle,transparent_0%,transparent_0.6rem,theme(colors.gray.300)_0.6rem,theme(colors.gray.300)_100%)] dark:bg-[radial-gradient(circle,transparent_0%,transparent_0.6rem,theme(colors.gray.600)_0.6rem,theme(colors.gray.600)_100%)]',
        'before:border-brand before:absolute before:left-1/2 before:top-0 before:h-4 before:w-4 before:-translate-x-1/2 before:-translate-y-1/2 before:-rotate-45 before:border-b-2 before:border-l-2',
        // 'after:bg-brand after:absolute after:left-1/2 after:top-0 after:h-5 after:w-5 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full',
      ],
      old: 'before:bg-brand relative h-0.5 overflow-visible text-gray-300 before:absolute before:-top-0.5 before:left-1/3 before:h-1 before:w-1/3 before:rounded dark:text-gray-600',
    },
  },
  defaultVariants: { variant: 'new' },
});

interface SeparatorProps extends VariantProps<typeof variants> {
  className?: string;
}

/** Give me a width via className prop. */
export const Separator = ({ className = '', variant }: SeparatorProps) => (
  <hr className={variants({ variant, className })} />
);
